module.exports = __webpack_public_path__ + "static/khoshzabaan-complete-d0efafc3d26dca29de2d58bec59428a7.jpg";